import { X } from 'lucide-react';

interface CloseButtonProps {
  onClick: () => void;
  variant?: 'light' | 'dark';
  ariaLabel?: string;
}

export function CloseButton({ onClick, variant = 'light', ariaLabel = 'Close' }: CloseButtonProps) {
  const colorClasses =
    variant === 'dark'
      ? 'text-white/70 hover:text-white hover:bg-white/10'
      : 'text-hilevel-gray hover:text-hilevel-slate hover:bg-hilevel-light';
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className={`ml-auto inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-transparent appearance-none cursor-pointer transition-colors touch:h-11 touch:w-11 ${colorClasses}`}
    >
      <X className="text-base" />
    </button>
  );
}
